module.exports = __webpack_public_path__ + "/56898458b2ff7b88077494e218702e2f.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/pricing-icon-phone@2x.png
 ** module id = 794
 ** module chunks = 0
 **/